module.exports = __webpack_public_path__ + "img/unstarted.0d1b3ef4.svg";